import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { ProjectCategoryDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-project-category-view',
  templateUrl: './project-category-view.component.html',
  styleUrls: ['./project-category-view.component.css'],
})
export class ProjectCategoryViewComponent implements OnInit {
  @Input() projectCategories: ProjectCategoryDto[];
  projectCategoryForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<ProjectCategoryDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.projectCategoryForm = this.fb.group({
      ProjectCategories: this.fb.array([]),
    });
    this.setProjectCategory();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display projectCategories
  setProjectCategory() {
    const control = this.projectCategoryForm.controls
      .ProjectCategories as FormArray;
    this.projectCategories.forEach((e) => {
      control.push(
        this.fb.group({
          ProjectCategoryName: e.ProjectCategoryName,
          id: e.id,
        })
      );
    });
  }

  // method to add ProjectCategory
  addProjectCategory() {
    const control = this.projectCategoryForm.controls
      .ProjectCategories as FormArray;
    control.insert(
      0,
      this.fb.group({
        ProjectCategoryName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete projectCategory from arrary list
  deleteProjectCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.projectCategoryForm.controls
          .ProjectCategories as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.projectCategories.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.projectCategories[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'projectCategory';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('projectCategory');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
